
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"highlight-stroke",attrs:{"d":"M10.76 8.94l1-.65a.33.33 0 000-.54l-1.54-1a.32.32 0 01-.22-.37l.35-1.84a.32.32 0 00-.35-.38l-1.84.35a.3.3 0 01-.32-.13L6.81 2.84a.33.33 0 00-.54 0l-1 1.54a.3.3 0 01-.32.13l-1.89-.35a.32.32 0 00-.37.38L3 6.38a.32.32 0 01-.14.32l-1.54 1a.33.33 0 000 .54l1.54 1a.34.34 0 01.14.42l-.35 1.83a.31.31 0 00.37.38l1.84-.35h0M9 7.92a2.51 2.51 0 10-3.22 2.48","fill":"none","stroke":"#fff","stroke-miterlimit":"10"}}),_c('path',{staticClass:"highlight-stroke",attrs:{"d":"M13 10.73h0a.73.73 0 000-.25 1.06 1.06 0 00-1.86-.71 2.47 2.47 0 00-4.86.38A2.12 2.12 0 007 14.28h6a1.78 1.78 0 100-3.55z","fill":"none","stroke":"#fff","stroke-miterlimit":"10"}})])
          )
        }
      }
    